import { Popover } from 'antd';
import react from 'react'
import { Typography } from 'antd';

interface IBbox{
    x: number;
    y: number;
    width: number;
    height: number;
    type: "Грамматическая" | "Пропуск слова" | "Иное";
    errors: string[];
}

const colors = {
    "Грамматическая": {
        'backColor': 'rgba(255, 77, 79, 0.31)',
        'borderColor': 'rgba(255, 77, 79, 1)'
    },
    "Пропуск слова": {
        'backColor': 'rgba(22, 119, 255, 0.31)',
        'borderColor': 'rgba(22, 119, 255, 1)'
    },
    "Иное": {
        'backColor': 'rgba(190, 200, 200, 0.31)',
        'borderColor': 'rgba(190, 200, 200, 0.31)'
    }
}

interface IPopoverContent{
    type: "Грамматическая" | "Пропуск слова" | "Иное";
    errors: string[];
}

const PopoverContent: react.FC<IPopoverContent> = (props) => {
    var errors = props.errors;
    var type = props.type;
    if (!errors.length) {
        errors = ['Ошибок не обнаружено']
        type = 'Пропуск слова';
    }

    return <div>
        <Typography.Text>
            Тип ошибки: {
                errors.map((e) => {
                    return <span 
                    style={{color: colors[type].borderColor}}>
                        {e + ' '} 
                    </span>
                })
            } 
            
        </Typography.Text>
    </div>
}


export const Bbox: react.FC<IBbox> = (props) => {
    const bbox_popover = <PopoverContent type={props.type} errors={props.errors}/>
    var type = 'Грамматическая';
    if (!props.errors.length) {
        type = 'Пропуск слова'
    }
    return <div style={{
        height: 0
    }}>
        <Popover title='Заголовок' content={bbox_popover}>
            <div style={{
                position: 'relative',
                left: props.x,
                top: props.y,
                width: props.width,
                height: props.height,
                backgroundColor: (colors as any)[(type as any)].backColor,
                border: `1px solid ${(colors as any)[type].borderColor}`,
                cursor: 'pointer'
            }}></div>
        </Popover>
        
   </div> 
}